import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

export const GridStyled = styled(Grid, {
  name: 'GridStyled',
})(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.secondary.main}`,
}));
